// extracted by mini-css-extract-plugin
export default {"container":"Notifications_container__rcgN4","notificationCounter":"Notifications_notificationCounter__oHDZb"};